// extracted by mini-css-extract-plugin
export default {"guideBox":"guidelines_guideBox__qBRVe","cancelBtn":"guidelines_cancelBtn__LgtPY","guideInner":"guidelines_guideInner__R6DLP","tagLbl":"guidelines_tagLbl__bObKN"};